module.exports = __webpack_public_path__ + "static/img/spriteImg@2x.98a2e8b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sprite/spriteImg@2x.png
// module id = fKZg
// module chunks = 41